// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type { DeletedVaultsOperations } from "./deletedVaults/index.js";
export type { OperationsOperations } from "./operations/index.js";
export type { PrivateLinkResourcesOperations } from "./privateLinkResources/index.js";
export type { RecoveryServicesOperations } from "./recoveryServices/index.js";
export type { RegisteredIdentitiesOperations } from "./registeredIdentities/index.js";
export type { ReplicationUsagesOperations } from "./replicationUsages/index.js";
export type { UsagesOperations } from "./usages/index.js";
export type { VaultCertificatesOperations } from "./vaultCertificates/index.js";
export type { VaultExtendedInfoOperations } from "./vaultExtendedInfo/index.js";
export type { VaultsOperations } from "./vaults/index.js";
